import axios from 'axios'
import { Notification } from 'element-ui'

axios.interceptors.request.use(config => {
  return config
}, error => {
  return Promise.reject(error)
})

// http响应拦截器
axios.interceptors.response.use(response  => {
  return response
}, error => {
  if (error.response){
    let status = error.response.status
    if (status == 502){
      Notification.error({
        title: '版本过期',
        message: '当前页面版本已过期，请刷新页面或稍后再试',
        position: 'bottom-right'
      })
    }else if (status == 401){
      Notification.error({
        title: '错误',
        message: '登录过期请重新登录',
        position: 'bottom-right'
      })
    }else if (status == 403){
      Notification.error({
        title: '错误',
        message: '权限不足',
        position: 'bottom-right'
      })
    }
    return Promise.reject(error)
  }
})

export default axios
